/**
 * @file brand-text.ts
 * @description Тексты бренда для показа в кабинете (phase19.16 Р1;
 * контракт §1 — шаблон копирайта с `{year}`). Один расчёт для «Настроек
 * сайта» и вкладки «Подвал».
 *
 * Приёмка Р2а (SB114): расчёт — общий `formatFooterCopyright` из shared, как
 * у витрины: `{legalName}` — наименование продавца из реквизитов (нет — название
 * сайта), `{siteName}` — название сайта; `null` → «© {year} {legalName}».
 */

import { formatFooterCopyright } from "@chaiberi/shared";

/** Копирайт с подставленным годом и правообладателем. */
export function copyrightPreview(template: string | null, siteName: string, year: number, legalName: string | null = null): string {
  return formatFooterCopyright(template, { siteName, legalName, year });
}
